"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "preseglie": {
    "3ea25955": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "skipSearch": false
    }],
    "ardessa": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cef911d": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "skipSearch": false
    }],
    "macenago": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38b29c09": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1790b49b": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "skipSearch": false
    }],
    "quintilago": [{
      "hkey": "4979807e",
      "slug": "preseglie",
      "name": "Preseglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;